import { h } from 'preact';
import { Theme } from './context';
import purpleTheme from '../sass/themes/purple.module.scss';
import lightTheme from '../sass/themes/light.module.scss';
import lightNewsTheme from '../sass/themes/light_news.module.scss';
import lightNewsFeedTheme from '../sass/themes/light_news_feed.module.scss';
import greenTheme from '../sass/themes/green.module.scss';
import transparentTheme from '../sass/themes/transparent.module.scss';
import bfDefaultTheme from '../sass/themes/bf_default.module.scss';
import bfDefaultHomeTheme from '../sass/themes/bf_default_home.module.scss';

const themeClassNamesMap = {
  bf_default: bfDefaultTheme,
  bf_default_home: bfDefaultHomeTheme,
  green: greenTheme,
  light: lightTheme,
  light_news: lightNewsTheme,
  light_news_feed: lightNewsFeedTheme,
  purple: purpleTheme,
  transparent: transparentTheme,
};

export const withTheme = (Component) => (props) =>
  (
    <Theme.Consumer>
      {(theme) => <Component theme={themeClassNamesMap[theme]} themeName={theme} {...props} />}
    </Theme.Consumer>
  );
